var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSocialMediaFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_in_Pfaden"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Arrow"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Social-Media"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M25.7,0.3V6h-2.8c-1,0-1.7,0.3-2.1,0.8c-0.4,0.5-0.5,1.3-0.5,2.3v4.1h5.2l-0.7,6.4h-4.5V36h-5.5 V19.6h-4.6v-6.4h4.6V8.5c0-2.7,0.6-4.8,1.9-6.2C17.9,0.7,19.6,0,21.6,0C23.4,0,24.7,0.1,25.7,0.3L25.7,0.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialMediaFacebook);
export default __webpack_public_path__ + "static/media/icon-social-media-facebook.ecc1038ecb0af94c0ff632b9daeec19a.svg";
export { ForwardRef as ReactComponent };